import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const LocationAnalysisValueButton = ({
    value,
    selection,
    onSelectionChange,
    analysisTypeUnit,
    isDisabled = false,
}) => {
    const isActive = selection.has(value);

    return (
        <button
            className={classNames('radius-selector__btn', {
                'radius-selector__btn--active': isActive,
                'radius-selector__btn--disabled': isDisabled && !isActive,
            })}
            onClick={() => !isDisabled && onSelectionChange(value)}
            disabled={isDisabled && !isActive}
        >
            {value} {analysisTypeUnit}
        </button>
    );
};

LocationAnalysisValueButton.propTypes = {
    value: PropTypes.number.isRequired,
    selection: PropTypes.object.isRequired,
    onSelectionChange: PropTypes.func.isRequired,
    analysisTypeUnit: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
};

export default LocationAnalysisValueButton;
